import * as React from "react";
import get from "lodash/get";
import Store, {
  listenToPath,
  stopListeningToPath,
} from "nexia_mobile/flux_like/store";

// Create a higher-order component that passes values from the store
// into the wrapped component as props, and updates those values when
// the values in the store change.
//
// Usage:
//   const ConnectedComponentClass = connect(pathDef, ComponentClass);
// Where:
//   * `pathDef` is an object of shape {[string]: string} that defines mappings
//     between props and values in the store; the keys are the prop names and the
//     values are the store value paths strings.
//   * `ComponentClass` is the "dumb" component. The props it receives should match
//     the prop names in `pathDef`.
// Example:
//
//   const MyComponent = ({ name }) => <div>Hello, {name}</div>;
//   console.log(Store.user.name); // "Bob"
//   const ConnectedMyComponent = connect({ name: "user.name" }, MyComponent);
//   // ConnectedMyComponent will render <div>Hello, Bob</div>
export default function connect(pathDef, ComponentClass) {
  const displayName =
    ComponentClass.displayName ||
    ComponentClass.name ||
    "<anonymous component>";

  const pathDefs = [];
  Object.entries(pathDef).forEach(([propName, storePath]) => {
    pathDefs.push({ propName, storePath });
  });

  return class ConnectedComponent extends React.Component {
    static displayName = `Connected(${displayName})`;

    constructor(props) {
      super(props);

      const initialState = {};
      this._listeners = {};
      pathDefs.forEach(({ propName, storePath }) => {
        initialState[propName] = get(Store, storePath);
        this._listeners[propName] = (newValue) => {
          this.setState({ [propName]: newValue });
        };
      });

      this.state = initialState;
    }

    componentDidMount() {
      pathDefs.forEach(({ propName, storePath }) => {
        listenToPath(storePath, this._listeners[propName]);
      });
    }

    componentWillUnmount() {
      pathDefs.forEach(({ propName, storePath }) => {
        stopListeningToPath(storePath, this._listeners[propName]);
      });
    }

    render() {
      return <ComponentClass {...this.state} {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/flux_like/store/connect.js